import { z } from "zod";
import { requireValidityOrder } from "@portal/common/validitySchema";

// Mensaje literal de SPEC-206 §10 (`FIELDS_REQUIRED`): el servidor devuelve
// el mismo código si el cliente saltea esta validación (mismo criterio que
// `FIELDS_REQUIRED_MESSAGE` en offers/offerSchemas.ts). PA-019-E
// (human-resolution-pa-019-e.json): título e imagen son los dos obligatorios
// — el antetítulo pierde su asterisco y la imagen lo gana, al revés que en
// el prototipo (`admin.jsx:218`, "La etiqueta y el título son obligatorios").
export const FIELDS_REQUIRED_MESSAGE =
  "Título e imagen son obligatorios para publicar";

const promotionFormObjectSchema = z.object({
  overlineEs: z.string(),
  overlineEn: z.string(),
  titleEs: z.string().trim().min(1, FIELDS_REQUIRED_MESSAGE),
  titleEn: z.string(),
  subtitleEs: z.string(),
  subtitleEn: z.string(),
  ctaEs: z.string(),
  ctaEn: z.string(),
  // SPEC-206 §2/PA-019-E: obligatoria para publicar, sin endpoint de subida
  // (contrato `imageUrl: format uri`, mismo precedente que
  // offers/welcome-content) — se edita como URL de texto.
  imageUrl: z.string().trim().min(1, FIELDS_REQUIRED_MESSAGE),
  // PLAN-007 Fase 4d: id del archivo ya subido y confirmado
  // (`uploadImage`/`FileUploadChip`), con prioridad sobre `imageUrl` en el
  // servidor (PromotionInput.imageFileId). Vacío cuando el operador no tocó
  // la imagen en esta sesión del formulario.
  imageFileId: z.string(),
  // PA-019-B: opcional, "" representa "sin oferta enlazada".
  offerId: z.string(),
  validFrom: z.string(),
  validUntil: z.string(),
  active: z.boolean(),
});

export const promotionFormSchema =
  promotionFormObjectSchema.superRefine(requireValidityOrder);
export type PromotionFormValues = z.infer<typeof promotionFormObjectSchema>;

// Mismo criterio que `REWARD_FORM_FIELDS`/`OFFER_FORM_FIELDS`: las claves que
// `PromotionEditor` renderiza, para asociar los rechazos por campo de la API.
export const PROMOTION_FORM_FIELDS = Object.keys(
  promotionFormObjectSchema.shape,
) as readonly (keyof PromotionFormValues)[];
